module.exports = __webpack_public_path__ + "static/media/footer-scanner-img.47b26797.svg";